import { FieldError, UseFormMethods, RegisterOptions } from "react-hook-form";
import { PropsWithChildren } from "react";
import classnames from "classnames";

import "./RadioInput.style.scss";

interface RadioInputProps {
  direction: "vertical" | "horizontal";
  optional?: boolean;
  error?: FieldError;
  label?: string;
  name: string;
}

interface RadioOptionProps {
  register: UseFormMethods["register"];
  rules?: RegisterOptions;
  dataRecurly?: string;
  error?: FieldError;
  disabled?: boolean;
  label?: string;
  subLabel?: string;
  value: string;
  name: string;
}

export function RadioInput({ error, name, label, optional, children, direction }: PropsWithChildren<RadioInputProps>) {
  const radioOptionClassName = classnames("radio-options", `radio-${direction}`, { "has-error": !!error });

  return (
    <div className="form-ctrl form-ctrl-radio">
      {label ? (
        <label className={classnames({ optional })} htmlFor={name}>
          {label}
        </label>
      ) : null}
      <div className={radioOptionClassName}>{children}</div>
      {error ? <span className="form-error">{error.message || "Error"}</span> : null}
    </div>
  );
}

export function RadioOption({
  register,
  value,
  rules,
  label,
  subLabel,
  disabled,
  name,
  dataRecurly,
}: RadioOptionProps) {
  return (
    <div className={classnames("radio-option", { disabled })}>
      <input
        {...(dataRecurly ? { "data-recurly": dataRecurly } : {})}
        {...(disabled ? { disabled } : {})}
        className="form-radio-input"
        ref={register(rules)}
        name={name}
        type="radio"
        value={value}
        id={value}
      />
      <div className="label-container">
        <label htmlFor={value}>{label || value}</label>
        <label className="sub-label" htmlFor={value}>
          {subLabel || value}
        </label>
      </div>
    </div>
  );
}
